<template>
    <ViewInscription/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ViewInscription from "@/components/Inscription/ViewInscription.vue";

    export default defineComponent({
      name: "ViewInscriptionPage",
      components: {
        
        ViewInscription,
      },
    });
  </script>